/* Newsletter attribution. No email is sent to the impression endpoint. */
(function () {
    "use strict";
    window.BouliesNewsletterAnalytics = {
        create: function (options) {
            var version = options.version;
            var storageKey = "boulies_newsletter_visitor_v1";
            var consentKey = "boulies_newsletter_analytics_consent";
            var current = null;
            var isOpen = false;
            var requestId = null;
            var requestEmail = null;
            var expiry = 30 * 86400000;
            var uuid = function () {
                if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID();
                if (!window.crypto || !window.crypto.getRandomValues) return null;
                return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, function (c) {
                    return (c ^ (window.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16);
                });
            };
            var read = function (key) {
                try {
                    return localStorage.getItem(key);
                } catch (_) {
                    return null;
                }
            };
            var remove = function (key) {
                try {
                    localStorage.removeItem(key);
                } catch (_) {
                    /* Storage may be blocked. */
                }
            };
            var write = function (key, value) {
                try {
                    localStorage.setItem(key, value);
                } catch (_) {
                    /* Use memory only. */
                }
            };
            var privacy = function () {
                return window.Shopify && window.Shopify.customerPrivacy;
            };
            var allowed = function () {
                if (window.Shopify && window.Shopify.designMode) return false;
                var choice;
                try {
                    choice = JSON.parse(read(consentKey));
                } catch (_) {
                    /* No valid explicit choice. */
                }
                if (choice && choice.expires > Date.now() && choice.allowed === false) return false;
                if (privacy() && typeof privacy().analyticsProcessingAllowed === "function") {
                    return privacy().analyticsProcessingAllowed() === true;
                }
                return !!(choice && choice.expires > Date.now() && choice.allowed === true);
            };
            var memoryVisitor;
            var visitor = function () {
                if (memoryVisitor) return memoryVisitor;
                var stored;
                try {
                    stored = JSON.parse(read(storageKey));
                } catch (_) {
                    /* Generate a new browser identifier. */
                }
                if (stored && stored.expires > Date.now() && /^[a-f0-9-]{36}$/i.test(stored.id)) memoryVisitor = stored.id;
                else {
                    memoryVisitor = uuid();
                    if (memoryVisitor) write(storageKey, JSON.stringify({ id: memoryVisitor, expires: Date.now() + expiry }));
                }
                return memoryVisitor;
            };
            var base = function () {
                return { shop: window.Shopify.shop, source: "uk_newsletter_popup", campaign_version: version };
            };
            var send = function (record) {
                if (typeof fetch !== "function" || typeof AbortController !== "function") return Promise.resolve();
                if (record.sent || record.pending || !allowed()) return record.pending || Promise.resolve();
                var controller = new AbortController();
                var timer = setTimeout(function () {
                    controller.abort();
                }, 2000);
                record.pending = fetch("https://app.boulies.com/api/newsletter/impression", {
                    method: "POST",
                    mode: "cors",
                    credentials: "omit",
                    signal: controller.signal,
                    body: new URLSearchParams(
                        Object.assign(base(), {
                            impression_id: record.id,
                            visitor_id: record.visitorId,
                            analytics_consent: "granted",
                            page_type: options.pageType,
                            device: window.matchMedia("(max-width: 650px)").matches ? "mobile" : "desktop",
                            trigger: record.trigger,
                        }),
                    ),
                })
                    .then(function (response) {
                        record.sent = response.ok;
                    })
                    .catch(function () {
                        /* Subscription remains available; missing exposure stays unlinked. */
                    })
                    .finally(function () {
                        clearTimeout(timer);
                        record.pending = null;
                    });
                return record.pending;
            };
            var measure = function () {
                if (!isOpen || document.hidden || !allowed() || !/^[a-z][a-z0-9_-]{0,47}$/.test(version || "")) return;
                var dialog = options.dialog;
                if (!dialog || !dialog.classList.contains("newsletter-actived") || !dialog.getClientRects().length || Number(window.getComputedStyle(dialog).opacity) <= 0) return;
                if (!current) return;
                if (!current.id) {
                    current.id = uuid();
                    current.visitorId = visitor();
                }
                if (current.id && current.visitorId) return send(current);
            };
            var consentChanged = function () {
                if (!allowed()) {
                    remove(storageKey);
                    memoryVisitor = null;
                    current = isOpen ? { trigger: current ? current.trigger : "manual" } : null;
                } else measure();
            };
            document.addEventListener("visitorConsentCollected", consentChanged);
            document.addEventListener("visibilitychange", measure);
            // The existing custom banner also calls the advertising callback on a timer.
            // Observe explicit button clicks only; that timer is not analytics consent.
            document.addEventListener("click", function (event) {
                var target = event.target.closest && event.target.closest(".bcww_accept, .bcww_deny");
                if (!target) return;
                var accepted = target.classList.contains("bcww_accept");
                write(consentKey, JSON.stringify({ allowed: accepted, expires: Date.now() + expiry }));
                if (privacy() && typeof privacy().setTrackingConsent === "function") {
                    privacy().setTrackingConsent({ analytics: accepted }, consentChanged);
                }
                consentChanged();
            });
            if (window.Shopify && typeof window.Shopify.loadFeatures === "function" && !privacy()) {
                window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (error) {
                    if (!error) consentChanged();
                });
            }
            return {
                opened: function (trigger) {
                    isOpen = true;
                    current = { trigger: trigger };
                    // Wait for the existing open animation, then verify actual visibility.
                    setTimeout(measure, 400);
                },
                closed: function () {
                    isOpen = false;
                    current = null;
                },
                submission: async function (email) {
                    var normalized = email.trim().toLowerCase();
                    if (!requestId || requestEmail !== normalized) {
                        requestId = uuid();
                        requestEmail = normalized;
                    }
                    var data = Object.assign(base(), { request_id: requestId || "" });
                    await measure();
                    if (allowed() && current && current.sent) {
                        data.impression_id = current.id;
                        data.analytics_consent = "granted";
                    }
                    return data;
                },
                responded: function () {
                    requestId = null;
                    requestEmail = null;
                },
            };
        },
    };
    window.dispatchEvent(new Event("boulies:newsletter-analytics-ready"));
})();
